<template>
  <div class="bottomContainer">
    <el-tabs v-model="activeName" type="card">
      <template v-for="(item,index) in componentConfig">
        <el-tab-pane :key="index" :label="item.label" :name="item.compName" />
      </template>
    </el-tabs>
    <component :is="activeName" :key="activeName" />
  </div>
</template>

<script>

import { generateTitle } from '@/utils/i18n'
export default {
  name: 'Payment_Link_Step',
  components: {
    Payment_Needs_Validation: () => import('./tabs/PaymentNeedsValidation'),
    Payment_Approved: () => import('./tabs/PaymentApproved')
  },
  data() {
    this.statusArr = ['Payment_Needs_Validation', 'Payment_Approved']
    return {
      activeName: 'Payment_Needs_Validation'
    }
  },
  computed: {
    componentConfig() {
      return [
        { compName: 'Payment_Needs_Validation', label: this.$t('data.creation') },
        { compName: 'Payment_Approved', label: this.$t('data.submission') }
      ]
    }
  },
  created() {
    const { status } = this.$route.query
    if (status) {
      this.activeName = this.statusArr[status]
    }
  },
  methods: {
    generateTitle
  }
}
</script>

<style scoped>
  .bottomContainer{
    margin: 20px;
    background: #fff;
    border-radius: 4px;
  }
</style>
